import { render } from "./ContentLabel.vue?vue&type=template&id=056cc022"
import script from "./ContentLabel.vue?vue&type=script&lang=js"
export * from "./ContentLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__